import {FormattedMessage} from "react-intl"
import React from "react"
import moment from "moment"

// import DataStore from "../../../stores/DataStore"

export default {
	load() {
		// let dgvalue = null

		// //Ak máme novú medikáciu predplníme diagnózu z dnešhého dekurzu
		// if (DataStore.patientDTO) {
		// 	const lastRecord = DataStore.patientDTO.get("lastRecord")
		// 	if (lastRecord && moment(lastRecord.created_at).isSame(moment(), "day")) {
		// 		dgvalue = lastRecord.diagnosis
		// 	}
		// }

		return {
			fields: {
				print: {
					value: false,
					rules: "boolean"
				},
				medicationType: {
					label: <FormattedMessage id="Patient.Form.Medication.MedicationType" defaultMessage="Prescription type" />,
					value: "ADMVACC",
					rules: "required"
				},
				vaccinationType: {
					label: <FormattedMessage id="Common.label.vaccinationType" />
				},
				medicationLocation: {
					label: <FormattedMessage id="Common.label.medicationLocation" />
				},
				drugs: {
					label: <FormattedMessage id="Common.label.drugs" />,
					rules: "required"
				},
				diagnosis: {
					label: <FormattedMessage id="Patient.Form.Medication.Diagnosis" />,
					rules: "required"
					// value: dgvalue
				},
				packs: {
					label: <FormattedMessage id="Patient.Form.Medication.Packs" />,
					rules: "required|min:1",
					value: 1
				},
				unit: {
					label: <FormattedMessage id="Common.label.unit" />,
					rules: "required"
				},
				medicationRoute: {
					label: <FormattedMessage id="Patient.Form.Medication.MedicationRoute" />,
					rules: "required"
				},

				batchNumber: {
					label: <FormattedMessage id="Patient.Form.Medication.BatchNumber" />
					//required_if: ["medicationType", "ADMVACC"]
					//rules: "required_if:medicationType,ADMVACC"
					// rules: "required"
				},
				expiration: {
					label: <FormattedMessage id="Patient.Form.Medication.Expiration" />,
					//required_if: ["medicationType", "ADMVACC"]
					rules: "required"
				},
				barcode: {
					label: <FormattedMessage id="Patient.Form.Medication.Barcode" />
				},

				type_code: {
					value: "POD"
				},

				version: {},
				productCode: {},

				doctor_id: {},
				personnel_id: {},
				provider_id: {},

				dosage_type: {},
				dateOfDelivery: {
					label: <FormattedMessage id="Common.label.administeredAt" />,
					rules: "required",
					type: "date",
					value: moment()
				}
			}
		}
	}
}
